import React, {FC, forwardRef} from 'react';

import {cn} from '@bem-react/classname';
import {TextInput} from '@gravity-ui/uikit';
import QuestionLayout, {QuestionLayoutType} from 'ui/components/QuestionLayout';
import getTextInputAria from 'ui/utils/getTextInputAria';

import {IntegerQuestionProps} from './IntegerQuestion.types';

import './IntegerQuestion.scss';

const cnIntegerQuestion = cn('IntegerQuestion');

const IntegerQuestion: FC<IntegerQuestionProps> = forwardRef<HTMLDivElement, IntegerQuestionProps>(
    function IntegerQuestion({error, className, value, label, ...props}, ref) {
        return (
            <QuestionLayout
                {...props}
                label={label}
                type={QuestionLayoutType.Column}
                className={cnIntegerQuestion('', [className])}
                error={error}
                control={
                    <div className={cnIntegerQuestion('Control')} ref={ref}>
                        <TextInput
                            size="l"
                            type="number"
                            error={Boolean(error)}
                            controlProps={{
                                step: 1,
                                pattern: '\\d*',
                                className: cnIntegerQuestion('InputControl'),
                                ...getTextInputAria(props.required, Boolean(error), props.id),
                                dir: 'ltr',
                            }}
                            {...props}
                            value={String(value)}
                            className={cnIntegerQuestion('Input')}
                        />
                    </div>
                }
            />
        );
    },
);
export default IntegerQuestion;
